export default "__VITE_ASSET__BUTpr$iJ__"